// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf } from "@altostra/type-validations";
import { string } from "@altostra/type-validations/lib/primitives";

export const isGetAlloysPartnersShopifyIntegrationIdFetchProductMetafieldsResult = objectOf({
  metafields: arrayOf(
    objectOf({
      id: string,
      namespace: string,
      key: string,
    })
  ),
});
